import React from 'react'
import PropTypes from 'prop-types';
import PapersGenerator from './PapersGenerator';

function Index(
    {
        expanded,
    }) {

    return (expanded && <PapersGenerator/>)
}

Index.propTypes = {
    classes: PropTypes.any,
}

export default Index;